var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SeparateInputs',_vm._g(_vm._b({attrs:{"inputs-mapping":_vm.inputMapping}},'SeparateInputs',{ ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }